import { CommonModule } from '@angular/common';
import { Component, EventEmitter, forwardRef, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-custom-inputgroup',
  templateUrl: './custom-inputgroup.component.html',
  styleUrls: ['./custom-inputgroup.component.scss'],
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(/* istanbul ignore next */() => CustomInputgroupComponent),
      multi: true
    }
  ],
  imports: [ButtonModule, CommonModule, InputGroupAddonModule, InputGroupModule, TooltipModule]
})
export class CustomInputgroupComponent implements OnChanges {

  @Input() dataKey: string = "";
  @Input() disabled: boolean = false;
  @Input() iconButton: string = "";
  @Input() inputValue: string = "";
  @Input() labelText: string = "";
  @Input() required: boolean = false;
  @Input() recovery: boolean = false;
  @Input() showClear: boolean = false;
  @Input() titleButton: string = "";

  @Output() onClick = new EventEmitter<Event>();
  @Output() valueChange = new EventEmitter<any>();

  showClearButton: boolean = false;

  constructor() { }

  ngOnChanges(changes: SimpleChanges) {
    const showClearChange = changes['showClear'];
    const inputValueChange = changes['inputValue'];

    if (showClearChange || inputValueChange) {
      this.showClearButton = !!this.showClear && !!this.inputValue;
    }
  }

  handleClick(event: Event) {
    this.onClick.emit(event);
  }

  onClear(): void {
    this.valueChange.emit(null);
  }

}
